

const convertDate2Str = (dateObj) =>{
 return dateObj.toISOString().split('T')[0]
}

export {convertDate2Str}